export default "__VITE_ASSET__bzK3_uUP__"